{
  "login-secret-with-password-page": {
    "buttons": {
      "forgot-password": "Passwort vergessen",
      "login": "Anmelden",
      "set-password": "Passwort festlegen",
      "update-password": "Passwort aktualisieren"
    },
    "text": {
      "new-password": "Ihr Passwort festlegen",
      "new-password-hint": "Ihr Passwort wird für zukünftige Anmeldungen benötigt",
      "password": "Passwort",
      "password-invalid": "Ihr Passwort ist ungültig. Bitte versuchen Sie es erneut!",
      "password-hint": "Bitte geben Sie Ihr Passwort ein, um sich einzuloggen",
      "update-password": "Neues Passwort",
      "update-password-hint": "Bitte geben Sie Ihr neues Passwort ein",
      "your-password": "Ihr Passwort"
    }
  }
}
